<template>
	<users-table v-if="active" :users="users" simplify title-bar>
		<create-user />
	</users-table>
</template>
<script>
import UsersTable from '@/Pages/Backend/Users/Table'
import CreateUser from '@/Pages/Backend/Users/Create'

export default {
	components: {
		UsersTable,
		CreateUser
	},
	props: {
		users: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		active: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			//
		}
	},
	watch: {
		active () {
			// Reset query string, so we don't confuse the other data tables
			window.history.pushState({}, document.title, window.location.pathname)
		}
	}
}
</script>
